import { Icon1, Icon2 } from "../../Common/Data/SvgIcons";
import IncomeCard from "./IncomeCard";
import IncomeChartClass from "./IncomechartCard";
import ProfileGreeting from "./ProfileGreetingCard";
import GrowthOverview from "./GrownCard";
import Login from "./creadential_keendroid";
import RecentToppers from "./Recent_toppers";
import UserCard from "./UserCard";
import TransactionCard from "./TransactionCard";
import { Container, Row, Col } from "reactstrap";
import image from "../../../assets/images/dummy_pic.jpeg";

import React from "react";
import { useEffect, useState } from "react";
// import { HiOutlineUserCircle } from 'react-icons/hi';
import { LuUsers } from "react-icons/lu";
import { BsEvStation } from "react-icons/bs";
import { FaChargingStation } from "react-icons/fa6";
import { GrTransaction } from "react-icons/gr";
import Loader from "../../../Modules/Settings/Loader";
import { Link } from "react-router-dom";
import Products from "./Products";
// import "./Products.css";
import Combo from "./Combo";
// import { faRupeeSign } from '@fortawesome/free-solid-svg-icons';

const Dashboard = () => {
  const [loading, setLoading] = useState(false);
  document.title = "Dashboard";

  return (
    <>
      {loading ? (
        <div className="loader-container">
          <Loader />
        </div>
      ) : (
        <Container fluid={true} className="dashboard-default-sec" style={{ paddingLeft: "16px" }}>


          <>
            <Products />

          </>
        </Container>)}

    </>
  )
};

export default Dashboard;
